const Skeleton = () => {
  return (
    <div className="flex max-h-[400px] flex-col gap-3 overflow-y-scroll">
      {Array(3)
        .fill(0)
        .map((_, index) => (
          <div
            key={index}
            className="flex w-full animate-pulse items-center gap-4"
          >
            <div className="mb-2 h-10 min-h-10 w-10 min-w-10 rounded-lg bg-monochrome-50"></div>
            <div className="col-span-4 flex w-full flex-col justify-between">
              <div className="mb-2 h-2 w-full rounded-md bg-monochrome-50"></div>
              <div className="mb-2 h-2 w-full rounded-md bg-monochrome-50"></div>
              <div className="mb-2 h-2 w-32 rounded-md bg-monochrome-50"></div>
            </div>
          </div>
        ))}
    </div>
  );
};

export default Skeleton;
